<template>
  <div class="daily-cargo-driver-administration">
    <div>
      <form-button
        @onClick="addNewDriver">
        Add new driver
      </form-button>
    </div>
    <table>
      <thead>
        <tr class="daily-cargo-driver-administration__head">
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index">
            <span />
            {{ header.label }}
          </th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(dailyCargo, dailyCargoIndex) in dailyCargoDriver"
          :key="'dailyCargoTable' + dailyCargoIndex">
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
            class="daily-cargo-driver-administration__field">
            <span>
              {{ formatField(dailyCargo[field.name], field.type) }}
            </span>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="editData(dailyCargo)">
              <img src="../../../assets/icon-edit.svg">
            </form-button>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="removeData(dailyCargo)">
              <img src="../../../assets/icon-close.svg">
            </form-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'Flight_Name', label: 'Flight Name', type: 'String' },
        { name: 'Customer_Name', label: 'Customer Name', type: 'String' },
        { name: 'Country_Name', label: 'Country Name', type: 'String' },
        { name: 'Provider_Name', label: 'Provider Name', type: 'String' },
        { name: 'Vehicle_Name', label: 'Vehicle Type', type: 'String' },
        { name: 'Transporter', label: 'Transporter', type: 'String' },
        { name: 'License_Number', label: 'License Number', type: 'String' },
        { name: 'Driver_Name', label: 'Driver Name', type: 'String' },
        { name: 'Plate_Number', label: 'Plate Number', type: 'String' },
        { name: 'Training_11_2_3_9_Valid_To', label: 'Training.11.2.3.9 Valid To', type: 'Date' },
        { name: 'Training_DGR_PK_7_8_Valid_To', label: 'Training.DGR.PK.7.8 Valid To', type: 'Date' },
        { name: 'Comments', label: 'Comments', type: 'String' }
      ],
      constants
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoDriver'])
  },
  created () {
    this.loadDailyCargoDriver()
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoDriver', 'deleteDailyCargoDriver']),
    editData (dailyCargo) {
      this.$router.push({ name: 'daily-cargo-edit-driver-administration', params: dailyCargo })
    },
    removeData (dailyCargo) {
      if (window.confirm('Are you sure you want to delete this driver?')) {
        dailyCargo.Status = false
        this.deleteDailyCargoDriver(dailyCargo)
      }
    },
    formatField (field, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      } else if (type === 'Number.2') {
        return this.numberFormat(field, 2, false)
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    addNewDriver () {
      this.$router.push('/daily-cargo-edit-driver-administration')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-driver-administration {
    width: 100%;
    height: calc(100vh - 205px);
    padding-bottom: 20px;
    overflow: auto;

    &__fields {
      display: grid;
      grid-template-columns: 19% 19% 19% 19% 19%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
      padding-bottom: 100px;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
  }
</style>
